import { API_CACHE_KEYS, API_PATHS } from '@/modules/common/constants';
import { getErrorMessage } from '@/modules/common/utils';
import { useToast } from '@pw-tech/omni-ui';
import { ApiClient } from '@pw-tech/web-sdk';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

const useIsEligibleForDirectAdmission = ({ enabled = true }: { enabled?: boolean }) => {
  const { toast: showToaster } = useToast();
  const { data, error, isFetching, refetch, isLoading } = useQuery<any>({
    queryKey: [API_CACHE_KEYS.IS_ELIGIBLE_FOR_DIRECT_ADMISSION],
    queryFn: () => ApiClient.get(API_PATHS.IS_ELIGIBLE_FOR_DIRECT_ADMISSION),
    enabled,
  });

  useEffect(() => {
    if (error) {
      const errorMessage = getErrorMessage(
        error,
        'Error in checking eligibility for direct admission'
      );
      showToaster({
        message: errorMessage,
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
      });
    }
  }, [error]);

  return {
    data: data?.data || null,
    error,
    isFetching,
    isLoading,
    refetch,
  };
};

export default useIsEligibleForDirectAdmission;
